import React, { useEffect, useState } from "react";
import Row from "react-bootstrap/Row";
import Col from "react-bootstrap/Col";
import Form from "react-bootstrap/Form";
import { Container } from "react-bootstrap";
import AnsweringPageFooter from "../../SharedComponents/AnswerIngPageFooter";

import FinishingModal from "../../SharedComponents/FinishingModal";
import TextSection from "../../SharedComponents/TextSection";
import ScrollableCard from "../../../SharedComponents/ScrollableCard";

export function CheckboxesImage({ q, Finish, isOnlyChecklist, Update }) {
  const [checkboxAnswersJson, setCheckboxAnswersJson] = useState([]);

  const [finishModalShow, setFinishModalShow] = useState(false);

  useEffect(() => {
    if (checkboxAnswersJson.length === 0) setCheckboxAnswersJson(q);
  }, []);

  const HandleOnChange = (id) => {
    const nonStateCheckboxAnswersJson = checkboxAnswersJson.map((prevAnswer) =>
      prevAnswer.questionId === id ? { ...prevAnswer, checked: !prevAnswer.checked } : prevAnswer
    );

    setCheckboxAnswersJson(nonStateCheckboxAnswersJson); // Update state with the new array

    if (Update) Update(nonStateCheckboxAnswersJson); // Pass the updated array to the Update function
  };

  const FindQuestionFromState = (id) => {
    return checkboxAnswersJson.find((x) => x.questionId === id);
  };

  let Finish_ = () => {
    Finish(checkboxAnswersJson);
    setFinishModalShow(false);
  };

  let DismisFinish = () => {
    setFinishModalShow(false);
  };

  let FinishCheckList = () => {
    if (isOnlyChecklist) setFinishModalShow(true);
    else Finish(checkboxAnswersJson);
  };

  let HandleAdjQuestions = () => {
    return q.map((q, i) => {
      return (
        <Row key={i} className="justify-content-center">
          <Col xs="8" md="5" style={{ margin: "10px" }}>
            <Row
              onClick={() => HandleOnChange(q.questionId)}
              className={"show-cursor"}
              style={{ backgroundColor: "white", borderRadius: "10px", padding: "10px" }}
            >
              <Col xs={"auto"}>
                <Form.Check type="checkbox" id={q.text} checked={FindQuestionFromState(q?.questionId)?.checked} />
              </Col>
              <Col>
                <div
                  style={{
                    fontSize: window.innerWidth <= 500 ? "15px" : "18px",
                    paddingLeft: "10px",
                    color: "#000",
                    fontFamily: "Plus Jakarta Sans",
                    fontWeight: "600",
                    lineHeight: "normal",
                  }}
                >
                  {q.text}
                </div>
              </Col>
            </Row>
          </Col>
        </Row>
      );
    });
  };

  return (
    <>
      <TextSection
        text="Aşağıdaki ifadelerden sizi tanımladığını düşündüklerinizi
          işaretleyiniz"
        class="question-text-segment text-container text-color-gray-light"
        style={{ minHeight: "130px" }}
      />

      <ScrollableCard>
        <Container style={{ marginBottom: 150 }} className="animate__animated  animate__fadeInDown ">
          {HandleAdjQuestions()}
        </Container>
      </ScrollableCard>
      <AnsweringPageFooter
        onClickFunction={FinishCheckList}
        isDisabled={false}
        buttonText={isOnlyChecklist ? "Tamamla" : "Devam"}
      />

      <FinishingModal show={finishModalShow} Finish={Finish_} DismisFinish={DismisFinish} />
    </>
  );
}
